<template>
  <div>
    <a-tabs default-active-key="basicInfo">
      <a-tab-pane
        key="basicInfo"
        tab="基础信息"
      >
        <a-card
          title="基础信息"
          style="width: 96%; margin: 1% auto 2%"
        >
          <template #extra>
            <a-select
              v-model="languageSelect"
              allow-clear
              placeholder="请选择翻译语言"
              show-search
              option-filter-prop="children"
              :style="{ width: '8vw' }"
              @change="handleLanguage"
            >
              <a-select-option
                v-for="(language, key) in languageOptions"
                :key="key"
                :value="language.value"
              >
                {{
                  language.label
                }}
              </a-select-option>
            </a-select>
          </template>
          <a-descriptions
            bordered
            :column="2"
          >
            <a-descriptions-item label="属性ID">
              {{ form.id }}
            </a-descriptions-item>
            <a-descriptions-item label="属性名称">
              {{ form.description.defaultMessage }}
            </a-descriptions-item>
            <a-descriptions-item label="属性标识符">
              {{ form.identifier }}
            </a-descriptions-item>
            <a-descriptions-item label="属性定义唯一标识">
              {{ form.encode }}
            </a-descriptions-item>
            <a-descriptions-item label="属性读写权限">
              <div v-if="form.accessMode === $constRepository.property.accessMode.readOnly">
                只读
              </div>
              <div v-else-if="form.accessMode === $constRepository.property.accessMode.writeOnly">
                只写
              </div>
              <div v-else-if="form.accessMode === $constRepository.property.accessMode.readWrite">
                可读写
              </div>
              <div v-else>
                未知
              </div>
            </a-descriptions-item>
            <a-descriptions-item label="属性的单位">
              <div>{{ form.unit || '' }}</div>
            </a-descriptions-item>
            <a-descriptions-item label="分级标签">
              <div v-if="form.level">
                {{ $constRepository.property.getPropertyLevelModeName(form.level) || '' }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item label="节点类型">
              <span v-if="form.propertyType === $constRepository.property.propertyType.root">父节点</span>
              <span v-else-if="form.propertyType === $constRepository.property.propertyType.child">子节点</span>
              <span v-else>未知</span>
              <a-popover
                trigger="hover"
                placement="left"
              >
                <template #content>
                  <ParentPropertyCard
                    :parent-id="form.parentId"
                    :meta-data="metaData"
                  />
                </template>
                <a-icon
                  v-if="form.parentId"
                  style="margin-left: 0.5rem;cursor: pointer;"
                  type="info-circle"
                />
              </a-popover>
            </a-descriptions-item>
            <a-descriptions-item label="属性类型">
              <span>{{ propertyType(form) }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="编辑方式">
              <span>{{ propertyEditMode(form) }}</span>
            </a-descriptions-item>
            <a-descriptions-item
              v-if="form.type.type !== 10"
              label="默认值"
            >
              <span>{{ form.type.defaultValue || '无' }}</span>
            </a-descriptions-item>
            <a-descriptions-item
              v-if="form.type.type === 10"
              label="默认值列表"
            >
              <div v-if="form.type.defaultValues && form.type.defaultValues.length">
                <a-tag
                  v-for="id in form.type.defaultValues"
                  :key="id"
                  color="blue"
                >
                  {{ id }}
                </a-tag>
              </div>
              <span v-else>无</span>
            </a-descriptions-item>
            <template v-if="form.type.editMode == $constRepository.productFormItem.editMode.input">
              <a-descriptions-item label="范围">
                <span v-if="form.type.type !== $constRepository.product.DATA_PRIMITIVE_TYPES.BOOL">{{
                  `${form.type.range.min}-${form.type.range.max}`
                }}</span>
                <span v-else> 无 </span>
              </a-descriptions-item>
            </template>
            <template v-if="form.type.editMode == $constRepository.productFormItem.editMode.select && form.type.type !== 10">
              <a-descriptions-item label="选项">
                <p
                  v-for="(option, index) in form.type.options"
                  :key="index"
                >
                  {{ `${option.value}:${option.description.defaultMessage}` }}
                </p>
              </a-descriptions-item>
            </template>
          </a-descriptions>
        </a-card>
      </a-tab-pane>
      <a-tab-pane
        key="codeEdit"
        tab="代码编辑器"
      >
        <a-card
          title="代码编辑器"
          style="width: 96%; margin: 1% auto; margin-bottom: 2%"
        >
          <VueJsonEditor
            v-model="form"
            :show-btns="false"
            mode="code"
            lang="zh"
            style="height: 700px"
          />
        </a-card>
      </a-tab-pane>
    </a-tabs>
    <a-button
      type="primary"
      class="creator-btn"
      style="margin: 0 0 2% 2%"
      @click="$router.back()"
    >
      返回
    </a-button>

    <!-- <a-card title="属性描述" class="" style="width: 80%; margin: 0 auto; margin-bottom: 2%；">
      <vue-json-editor
        class="default-message-edit"
        v-model="form.description"
        :showBtns="false"
        :mode="'code'"
        lang="zh"
      />
    </a-card> -->
  </div>
</template>

<script>
import vueJsonEditor from 'vue-json-editor'
import ParentPropertyCard from './components/ParentPropertyCard'

export default {
  name: 'PropertyDetail',
  components: { VueJsonEditor: vueJsonEditor, ParentPropertyCard },
  data() {
    return {
      languageSelect: this.$constRepository.language.FILTER_OPTION_ZH_CN.value,
      languageOptions: this.$constRepository.language.FILTER_OPTIONS,
      filterOptions: this.$constRepository.property.FILTER_NODES,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      metaData: this.$store.state.metaData,
      form: {
        identifier: null,
        name: null,
        propertyType: null,
        accessMode: null,
        description: {
          key: '',
          defaultMessage: '',
        },
        type: {
          type: undefined,
          editMode: undefined,
          defaultValue: '',
          range: {
            min: '',
            max: '',
          },
          options: [
            {
              value: '',
              description: {
                key: '',
                defaultMessage: '',
              },
            },
          ],
          defaultValueDescription: {
            key: '',
            defaultMessage: '',
          },
        },
      },
    }
  },
  computed: {
    propertyType() {
      return (property) => {
        const res = this.metaData.dataPrimitiveTypes?.find(type => type.value === property.type.type)
        if (res)
          return res.name

        return ''
      }
    },
    propertyEditMode() {
      return property => this.$constRepository.productFormItem.editModeText[property.type.editMode] || ''
    },
  },
  async mounted() {
    if (this.$route.params.id)
      await this.listPropertiesById(this.$route.params.id)
  },
  methods: {
    async handleLanguage() {
      await this.listPropertiesById(this.$route.params.id)
    },
    async listPropertiesById(ids) {
      const params = {
        id: ids,
      }
      const headers = {
        'accept-language': this.languageSelect,
      }
      const response = await this.$apiManager.property.getPropertiesById(params, headers)
      this.form = response.data
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.jsoneditor-poweredBy {
  display: none;
}

// /deep/.jsoneditor-outer {
//   height: 25vw;
// }
/deep/ .jsoneditor-vue {
  height: 100%;
}

.creator-btn {
  margin-top: 2%;
}

.default-message-edit {
  height: 8vw;

  /deep/.jsoneditor-outer {
    height: 8vw;
  }
}
</style>
